module.exports = __webpack_public_path__ + "img/mtx2.0011b448.jpg";